import type { Location } from 'react-router-dom';

/** Returns the location's pathname concatenated with the search value. */
export function getFullPathFromLocation(location?: Location) {
  if (!location) {
    return undefined;
  }
  return `${location.pathname}${location.search ?? ''}`;
}
